export default __webpack_public_path__ + "static/media/down-arrow-left.75095c56.svg";